module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/sitebuilder/icons/icon-9-tranparent.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/sitebuilder/icons/icon-9-tranparent.png
// module id = Q0bp
// module chunks = 0